module.exports = __webpack_public_path__ + "media/images/plans/ceremony/main-b175cd5b206d980a09948ffcd5af0334.jpg";